import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { lack } from "../utils"; // replace with your actual image import

gsap.registerPlugin(ScrollTrigger);

const Highlights2 = () => {
  useEffect(() => {
    // Optional: Add GSAP animations or ScrollTrigger logic here
  }, []);

  return (
    <section className="w-full min-h-screen bg-[#1E1E1E] text-white py-16 lg:py-20 px-8">
      {/* Main Heading and Subheading */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h1 className="text-5xl md:text-6xl font-extrabold">
          Wellness und Beauty
        </h1>
        <p className="text-xl md:text-2xl mt-4 text-gray-200 max-w-3xl mx-auto">
          Erleben Sie verjüngende Massagen, Maniküre, Pediküre und
          Gesichtsbehandlungen für Ihre ultimative Entspannung.
        </p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        {/* Left: Image */}
        <div>
          <img
            src={lack}
            alt="Massage Spa"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Right: Service Highlights */}
        <div className="space-y-8">
          {/* Card 1 */}
          <div>
            <h3 className="text-2xl md:text-3xl font-semibold">
              Revitalizing Gesichtsbehandlung
            </h3>
            <p className="text-gray-200 mt-2 leading-relaxed">
              Erfrischen Sie Ihre Haut mit unserer maßgeschneiderten
              Gesichtsbehandlung, die alle Ihre Bedürfnisse anspricht.
            </p>
          </div>

          {/* Card 2 */}
          <div>
            <h3 className="text-2xl md:text-3xl font-semibold">
              Relaxing Massage Therapie
            </h3>
            <p className="text-gray-200 mt-2 leading-relaxed">
              Gönnen Sie sich wohltuende Massagen, die auf Ihre Bedürfnisse
              zugeschnitten sind und tiefe Entspannung bieten.
            </p>
          </div>

          {/* Card 3 */}
          <div>
            <h3 className="text-2xl md:text-3xl font-semibold">
              Nagelpflege Services
            </h3>
            <p className="text-gray-200 mt-2 leading-relaxed">
              Verwöhnen Sie Ihre Hände und Füße mit unseren luxuriösen Maniküre-
              und Pedikürebehandlungen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Highlights2;
